import { Link } from "react-router-dom";
import { scrollTo } from "./Nav";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-ink text-paper border-t border-paper/10 pt-16 pb-8 overflow-hidden">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <p className="font-display font-semibold tracking-tighter leading-none text-[11.5vw] md:text-[9vw] text-outline-paper select-none" aria-hidden="true">
                WORX
            </p>
            <div className="mt-10 grid sm:grid-cols-3 gap-10 text-sm">
                <div>
                    <p className="font-display font-medium text-lg">Consulting WorX</p>
                    <p className="mt-2 text-paper/50 leading-relaxed">
                        Websites, web apps & custom CRM — built for your business. 1-on-1 AI classes too.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-paper/40 uppercase tracking-[0.2em] text-xs mb-1">Site</p>
                    {["Services", "About", "Pricing", "Booking", "Contact"].map((l) => (
                        <a key={l} href={`#${l.toLowerCase()}`} onClick={scrollTo(`#${l.toLowerCase()}`)} data-testid={`footer-link-${l.toLowerCase()}`} className="text-paper/70 hover:text-worx transition-colors w-max">
                            {l}
                        </a>
                    ))}
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-paper/40 uppercase tracking-[0.2em] text-xs mb-1">Company</p>
                    <Link to="/admin" data-testid="footer-admin-link" className="text-paper/70 hover:text-worx transition-colors w-max">
                        Owner console
                    </Link>
                </div>
            </div>
            <div className="mt-12 pt-6 border-t border-paper/10 flex flex-wrap justify-between gap-3 text-xs text-paper/40">
                <span>© 2026 Consulting WorX. All rights reserved.</span>
                <span>Built for humans, by humans + AI.</span>
            </div>
        </div>
    </footer>
);
